import { IError } from '../../httpClient/serverApi/types/IError';

export class ListResultWithToken<T> {

  public items: T[];
  public nextPageToken: string;
  public errors?: IError[];

  constructor(items: T[], nextPageToken: string, errors?: IError[]) {
    this.items = items;
    this.nextPageToken = nextPageToken;
    this.errors = errors || [];
  }

  static empty<T>(): ListResultWithToken<T> {
    return new ListResultWithToken<T>([], null);
  }

}